import { createSlice } from "@reduxjs/toolkit";

type INorouzState = {
  isShowBottomSheet: boolean;
  norouzDate: string;
};

const initialState: INorouzState = {
  isShowBottomSheet: true,
  norouzDate: "2025-03-18T20:30:00.000Z",
};

const norouzSlice = createSlice({
  name: "norouz",
  initialState,
  reducers: {
    closeNorouzBottomSheet: (state) => {
      state.isShowBottomSheet = false;
    },
  },
});

export default norouzSlice.reducer;

export const { closeNorouzBottomSheet } = norouzSlice.actions;
